import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export const initialState = () => ({
  hosting: {},
  hosting_detail: {},
  hosting_error: null,
  hostingPopulated: false,
  domainsList: [],
  subdomainsList: [],
  resellerSubAccounts: [],
  resellerPackages: [],
  resellerFeatureLists: [],
  resellerThemes: [],
  resellerFeatures: [],
  resellerPrivileges: {},
  resellerZones: [],
})

const state = initialState

const module = {
  state,
  getters,
  mutations,
  actions
}

export default module
